/* Fun & Fancy collection merchandising: available products precede sold-out products without forcing a filter. */
(() => {
  const availabilityKey = 'filter.v.availability';
  let cache = new Map();
  if (window.ffStockPriorityLoaded) return;
  window.ffStockPriorityLoaded = true;
  let requestVersion = 0;

  const fetchSourcePage = async (container, availability, page) => {
    const sectionId = container.dataset.sectionId;
    const url = new URL(window.location.href);
    url.searchParams.delete(availabilityKey);
    url.searchParams.set(availabilityKey, availability);
    url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', sectionId);

    const key = url.toString();
    if (!cache.has(key)) {
      cache.set(key, fetch(key, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then((response) => {
          if (!response.ok) throw new Error('Stock-priority request failed: ' + response.status);
          return response.text();
        })
        .then((html) => {
          const template = document.createElement('template');
          template.innerHTML = html;
          return Array.from(template.content.querySelectorAll('.cc-filters-results .grid-flex > .product-block'));
        }));
    }

    return cache.get(key);
  };

  const fetchRange = async (container, availability, start, end, className) => {
    const pageSize = Number(container.querySelector('[data-ff-stock-counts]').dataset.ffPageSize) || 12;
    const cards = [];
    // Shopify can include partly sold-out products in the sold-out filter.
    // Skip those before counting offsets, so products never repeat across pages.
    let sourcePage = availability === '0' ? 1 : Math.floor(start / pageSize) + 1;
    let sourceOffset = availability === '0' ? start : start % pageSize;

    while (cards.length < end - start) {
      const pageCards = await fetchSourcePage(container, availability, sourcePage);
      if (pageCards.length === 0) break;

      const matchingCards = className
        ? pageCards.filter((card) => card.classList.contains(className))
        : pageCards;

      for (const card of matchingCards.slice(sourceOffset)) {
        cards.push(card);
        if (cards.length >= end - start) break;
      }

      sourceOffset = Math.max(0, sourceOffset - matchingCards.length);
      sourcePage += 1;
    }

    return cards;
  };

  const prioritizeAvailableProducts = async () => {
    if (!document.body.classList.contains('template-collection')) return;
    if (window.Shopify && window.Shopify.designMode) return;

    const version = ++requestVersion;
    cache = new Map();
    const originalURL = window.location.href;
    const url = new URL(originalURL);
    if (url.searchParams.getAll(availabilityKey).some((value) => value !== '')) return;

    const container = document.querySelector('[data-section-type="collection-template"]');
    const grid = container && container.querySelector('.cc-filters-results .grid-flex');
    if (!container || !grid || !grid.querySelector('.product-block')) return;

    const counts = container.querySelector('[data-ff-stock-counts]');
    if (!counts) return;
    const availableCount = Number(counts.dataset.ffAvailableCount);
    const totalCount = Number(counts.dataset.ffTotalCount) || 0;
    const pageSize = Number(counts.dataset.ffPageSize) || 12;
    const currentPage = Number(counts.dataset.ffCurrentPage) || Number(url.searchParams.get('page')) || 1;
    const rangeStart = (currentPage - 1) * pageSize;
    const rangeEnd = Math.min(rangeStart + pageSize, totalCount);

    if (availableCount <= 0 || rangeStart >= totalCount) return;

    grid.setAttribute('aria-busy', 'true');
    grid.classList.add('ff-stock-priority-loading');

    try {
      const availableStart = Math.min(rangeStart, availableCount);
      const availableEnd = Math.min(rangeEnd, availableCount);
      const soldOutStart = Math.max(0, rangeStart - availableCount);
      const soldOutEnd = Math.max(0, rangeEnd - availableCount);
      const requests = [];

      if (availableEnd > availableStart) {
        requests.push(fetchRange(container, '1', availableStart, availableEnd, 'ff-product--available'));
      } else {
        requests.push(Promise.resolve([]));
      }

      if (soldOutEnd > soldOutStart) {
        requests.push(fetchRange(container, '0', soldOutStart, soldOutEnd, 'ff-product--sold-out'));
      } else {
        requests.push(Promise.resolve([]));
      }

      const results = await Promise.all(requests);
      if (version !== requestVersion || window.location.href !== originalURL || !grid.isConnected) return;

      const orderedCards = results[0].concat(results[1]);
      if (orderedCards.length === rangeEnd - rangeStart) {
        grid.replaceChildren(...orderedCards);
        grid.dataset.ffStockOrdered = 'true';
        document.dispatchEvent(new CustomEvent('ff:stock-ordered'));
      }
    } catch (error) {
      console.warn(error);
    } finally {
      if (version === requestVersion) {
        grid.removeAttribute('aria-busy');
        grid.classList.remove('ff-stock-priority-loading');
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prioritizeAvailableProducts, { once: true });
  } else {
    prioritizeAvailableProducts();
  }

  document.addEventListener('filters-applied', () => {
    window.setTimeout(prioritizeAvailableProducts, 0);
  });
})();
